// The one react-query client; lives here (not in main.tsx) so auth.ts can
// drop the cache when the token or the active workspace changes.

import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // TODO: tune staleTime/refetchInterval per query — dashboard counts
      // and an active run's status should poll (or move to SSE) while
      // static lookups (roles, skills, ...) shouldn't refetch this eagerly.
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})
